import React, { useState, useEffect, useRef } from "react";
import slideshowData from "../../json/slideshowData.json"; // Import JSON file
import "../../styles/Home/slideshow.scss";

// Import images
import SiliconWafers from "../../images/backgroundImg/silicon wafers.png";
import SemiconductorMaterials from "../../images/backgroundImg/semiconductor materials.jpg";
import SemiconductorMachineries from "../../images/backgroundImg/semiconductor machinery_3.jpg";
import THREEDVisualisationAndGames from "../../images/backgroundImg/3D visualisation and games.jpg";
import ElectronicEmbeddedSystem from "../../images/backgroundImg/Electronic embedded system.webp";
import RadarSystem from "../../images/backgroundImg/Radar system.jpg";
import SonarSystem from "../../images/backgroundImg/Sonar system_1.png";
import RadarAndSonarSoftware from "../../images/backgroundImg/Radar and sonar software.jpeg";
import VFX from "../../images/backgroundImg/VFX.jpg";
import TargetingAndNavigationSystem from "../../images/backgroundImg/Targeting and navigation system.jpg";
import SimulationSoftware from "../../images/backgroundImg/Simulation software_1.jpeg";

// Map JSON `image` values to actual imported images
const imageMap = {
  SiliconWafers,
  SemiconductorMaterials,
  SemiconductorMachineries,
  THREEDVisualisationAndGames,
  ElectronicEmbeddedSystem,
  RadarSystem,
  SonarSystem,
  RadarAndSonarSoftware,
  VFX,
  TargetingAndNavigationSystem,
  SimulationSoftware,
};

const SlideShow = () => {
  const carouselRef = useRef(null);
  const sliderRef = useRef(null);
  const thumbnailRef = useRef(null);

  const timeRunning = 9000;
  const timeAutoNext = 10000;

  let runTimeOut = useRef(null);
  let runNextAuto = useRef(null);

  // Reorder thumbnail data to start from the second image and move the first image to the end
  const reorderedThumbnailData = [...slideshowData.slice(1), slideshowData[0]];

  // Move to the next or previous slide
  const showSlider = (type) => {
    const sliderItems = sliderRef.current.querySelectorAll(".item");
    const thumbnailItems = thumbnailRef.current.querySelectorAll(".item");

    // Remove both transition classes before adding a new one
    carouselRef.current.classList.remove("next", "prev");

    // Force reflow to reset animation state
    void carouselRef.current.offsetHeight;

    if (type === "next") {
      sliderRef.current.appendChild(sliderItems[0]);
      thumbnailRef.current.appendChild(thumbnailItems[0]);
      carouselRef.current.classList.add("next");
    } else {
      sliderRef.current.prepend(sliderItems[sliderItems.length - 1]);
      thumbnailRef.current.prepend(thumbnailItems[thumbnailItems.length - 1]);
      carouselRef.current.classList.add("prev");
    }

    clearTimeout(runTimeOut.current);
    runTimeOut.current = setTimeout(() => {
      carouselRef.current.classList.remove("next", "prev");
    }, timeRunning);

    resetAutoSlide();
  };

  // Automatically move to the next slide
  const autoSlide = () => {
    runNextAuto.current = setTimeout(() => {
      showSlider("next");
    }, timeAutoNext);
  };

  // Reset auto-slide timer
  const resetAutoSlide = () => {
    clearTimeout(runNextAuto.current);
    autoSlide();
  };

  // Track touch start and end positions
  let touchStartX = useRef(0);
  let touchEndX = useRef(0);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].clientX;
    if (touchStartX.current - touchEndX.current > 50) {
      showSlider("next");
    } else if (touchEndX.current - touchStartX.current > 50) {
      showSlider("prev");
    }
  };

  // useEffect(() => {
  //   autoSlide();

  //   // Keyboard navigation event listener
  //   const handleKeydown = (e) => {
  //     if (e.key === "ArrowLeft") {
  //       showSlider("prev");
  //     } else if (e.key === "ArrowRight") {
  //       showSlider("next");
  //     }
  //   };

  //   // Adding event listener for keyboard and touch
  //   window.addEventListener("keydown", handleKeydown);
  //   carouselRef.current.addEventListener("touchstart", handleTouchStart);
  //   carouselRef.current.addEventListener("touchend", handleTouchEnd);

  //   return () => {
  //     clearTimeout(runNextAuto.current);
  //     clearTimeout(runTimeOut.current);
  //     // Clean up event listener
  //     window.removeEventListener("keydown", handleKeydown);
  //     carouselRef.current.removeEventListener("touchstart", handleTouchStart);
  //     carouselRef.current.removeEventListener("touchend", handleTouchEnd);
  //   };
  // }, []);

  useEffect(() => {
    autoSlide();
  
    // Keyboard navigation event listener
    const handleKeydown = (e) => {
      if (e.key === "ArrowLeft") {
        showSlider("prev");
      } else if (e.key === "ArrowRight") {
        showSlider("next");
      }
    };
  
    // Adding event listener for keyboard and touch
    window.addEventListener("keydown", handleKeydown);
    carouselRef.current?.addEventListener("touchstart", handleTouchStart);
    carouselRef.current?.addEventListener("touchend", handleTouchEnd);
  
    return () => {
      clearTimeout(runNextAuto.current);
      clearTimeout(runTimeOut.current);
      // Clean up event listener safely
      window.removeEventListener("keydown", handleKeydown);
      carouselRef.current?.removeEventListener("touchstart", handleTouchStart);
      carouselRef.current?.removeEventListener("touchend", handleTouchEnd);
    };
  }, []);  

  const handleRedirect = (url) => {
    window.location.href = url;
  };

  return (
    <section className="slide-show" ref={carouselRef}>
      <div className="list" ref={sliderRef}>
        {slideshowData.map((slide, index) => (
          <div className="item" key={index}>
            <img src={imageMap[slide.image]} alt={slide.title} />
            <div className="content">
              <div className="title">{slide.title}</div>
              <div className="description">{slide.description}</div>
              <div className="buttons">
                <button onClick={() => handleRedirect(slide.SeeMore)}>SEE MORE</button>
                <button onClick={() => handleRedirect(slide.VisitSite)}>VISIT SITE</button>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="thumbnail" ref={thumbnailRef}>
        {reorderedThumbnailData.map((slide, index) => (
          <div className="item" key={index}>
            <img src={imageMap[slide.image]} alt={slide.title} />
            <div className="content">
              <div className="title">{slide.title}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="arrows">
        <button onClick={() => showSlider("prev")} id="prev">
          &lt;
        </button>
        <button onClick={() => showSlider("next")} id="next">
          &gt;
        </button>
      </div>
    </section>
  );
};

export default SlideShow;
